import { atom } from 'jotai'

import { authDataAtom } from './AtomAuth'

// A quick way to get auth user, don't use it as user since the information may be out of date
export const authUserAtom = atom((get) => get(authDataAtom)?.user || null)

export const isAuthenticatedAtom = atom((get) => {
  const authData = get(authDataAtom)
  return authData && authData.token !== null
})

export const isInstructorAtom = atom((get) => get(authUserAtom)?.roles?.includes('INSTRUCTOR'))

export const isAdminAtom = atom((get) => get(authUserAtom)?.roles?.includes('ADMIN'))
